import _ from 'lodash'
import dayjs from 'dayjs'

export const yearBoundaryFn = (yearBoundary, minDate, maxDate, lang) => {
  let thisYear
  const resLang = lang ? lang : localStorage.getItem('lang')
  const resYearBoundary = yearBoundary ? yearBoundary : 10

  resLang === 'en' ? (thisYear = dayjs().year()) : (thisYear = dayjs().add(543, 'year').year())

  const minYear = minDate ? dayjs(minDate).year() : thisYear - resYearBoundary
  const maxYear = maxDate ? dayjs(maxDate).year() : thisYear + resYearBoundary
  return _.range(minYear, maxYear + 1, 1)
}

export const dateDisplay = (data) => {
  if (data) {
    if (localStorage.getItem('lang') === 'th') {
      return dayjs(new Date(data)).format('DD/MM/') + (parseInt(dayjs(new Date(data)).format('YYYY')) + 543)
    } else {
      return dayjs(new Date(data)).format('DD/MM/YYYY')
    }
  }
  return ''
}

export const dateTimeDisplay = (data) => {
  if (data) {
    const date = new Date(data)
    if (localStorage.getItem('lang') === 'th') {
      return (
        dayjs(date).format('DD/MM/') + (parseInt(dayjs(date).format('YYYY')) + 543) + ' ' + dayjs(date).format('HH:mm')
      )
    } else {
      return dayjs(date).format('DD/MM/YYYY') + ' ' + dayjs(date).format('HH:mm')
    }
  }
  return ''
}

export const timeDisplay = (data) => {
  if (data) {
    const date = new Date(data)
    return dayjs(date).format('HH:mm')
  }
  return ''
}

export const yearDisplay = (data) => {
  if (data) {
    if (localStorage.getItem('lang') === 'th') {
      return parseInt(dayjs(new Date(data)).format('YYYY')) + 543
    } else {
      return dayjs(new Date(data)).format('YYYY')
    }
  }
}

export const dateStringToPicker = (date = new Date()) => {
  if (localStorage.getItem('lang') === 'th') {
    return (date.getFullYear() + 543).toString() + '-' + dayjs(date).format('MM-DD').toString()
  } else {
    return dayjs(date).format('YYYY-MM-DD').toString()
  }
}

export const convertDate2FullDate = (val) => {
  if (val) {
    const monthNamesThai = [
      'มกราคม',
      'กุมภาพันธ์',
      'มีนาคม',
      'เมษายน',
      'พฤษภาคม',
      'มิถุนายน',
      'กรกฎาคม',
      'สิงหาคม',
      'กันยายน',
      'ตุลาคม',
      'พฤษจิกายน',
      'ธันวาคม'
    ]
    const monthNamesEng = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ]
    var date = new Date(val)
    if (localStorage.getItem('lang') === 'th') {
      return date.getDate() + ' ' + monthNamesThai[date.getMonth()] + ' ' + (date.getFullYear() + 543)
    } else {
      return date.getDate() + ' ' + monthNamesEng[date.getMonth()] + ' ' + date.getFullYear()
    }
  }
  return ''
}
